import React from 'react';
import PropTypes from 'prop-types';
import imageUrlBuilder from '@sanity/image-url';
import { getClient } from '../lib/sanity.server';
import Image from 'next/image';
import { getResponsiveBackgroundImageWidth } from '@lilbit/shared';
import { CameraIcon } from '@heroicons/react/24/outline';

const builder = imageUrlBuilder(getClient());

const ImageSerializer = ({ node }) => {
  const { imageTag, photoCredits, asset } = node;
  let backgroundImageWidth = getResponsiveBackgroundImageWidth();
  if (!asset) {
    return undefined;
  }
  return (
    <figure className="font-objektiv">
      <Image
        src={builder.image(asset).auto('format').url()}
        width={backgroundImageWidth}
        height={500}
        quality={40}
        objectFit="cover"
        alt={imageTag && imageTag[0]}
      />
      {photoCredits && (
        <figcaption>
          <div className="flex">
            <div>
              <CameraIcon className="h-5 w-5 text-gray-400" />
            </div>
            <div className="text-gray-500 italic pl-4 text-p-md lg:text-p-sm-desktop">
              <p>{photoCredits[0]}</p>
            </div>
          </div>
        </figcaption>
      )}
    </figure>
  );
};

ImageSerializer.propTypes = {
  node: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    asset: PropTypes.shape({
      _ref: PropTypes.string,
    }),
  }),
};
export default ImageSerializer;
